<template>
  <div>
    <div class="wrapper">
      <router-link
        :to="{ path: '/detail', query: { api: 'news_details', id: item.id } }"
        tag="div"
        v-for="(item, index) in list"
        :style="{ marginRight: (index + 1) % 3 == 0 ? '0' : '40px' }"
      >
        <p class="date">{{ item.cate_name }} | {{ item.create_time }}</p>
        <img :src="item.img" alt="" />
        <p class="name">{{ item.title }}</p>
        <p class="content">
          {{ filterText(item.intro, 20) }}
        </p>
      </router-link>
    </div>
    <p class="more" @click="more">点击加载更多...</p>
  </div>
</template>

<script>
import { news } from '../utils/api'
export default {
  data() {
    return {
      list: [],
      page: 1,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    more() {
      this.page++
      this.getList()
    },
    getList() {
      news(this.page, (r) => {
        this.list = this.list.concat(r.data.data)
        if (r.data.data.length == 0) {
          this.$message.info('没有更多了')
        }
      })
    },
  },
}
</script>

<style lang="less" scoped >
.wrapper {
  display: flex;
  flex-wrap: wrap;
  padding-top: 80px;
  & > div:hover {
    .date,
    .name,
    .content {
      color: #006C8F;
      border-color: #006C8F;
    }
  }
  & > div {
    width: 30%;
    cursor: pointer;
    margin-bottom: 40px;
    .date {
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 31px;
      color: #909090;
      padding-bottom: 12px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      border-bottom: 1px solid #1a1a1a;
      margin-bottom: 40px;
      transition: all 0.15s linear;
    }
    img {
      width: 100%;
      height: 232px;
      object-fit: cover;
    }
    .name {
      margin: 20px 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      transition: all 0.15s linear;
    }
    .content {
      transition: all 0.15s linear;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 28px;
      color: #909090;
    }
  }
}
.more:active {
  opacity: 0.78;
}
.more {
  text-align: center;
  cursor: pointer;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 24px;
  color: #909090;
  margin-top: 40px;
  margin-bottom: 80px;
}
@media (max-width: 767px) {
  .wrapper {
    margin-top: 1.24rem;
    padding: 0 0.34rem;
    box-sizing: border-box;
    & > div {
      width: 100%;
      margin-right: 0 !important;
      margin-bottom: 0.38rem;
      .date {
        padding-bottom: 0.16rem;
        margin-bottom: 0.24rem;
        font-size: 0.28rem;
        line-height: 0.28rem;
      }
      img {
        vertical-align: middle;
      }
      .name {
        font-size: 0.32rem;
        margin-top: 0.22rem;
        margin-bottom: 0.12rem;
      }
      .content {
        font-size: 0.28rem;
      }
    }
  }
  .more {
    margin: 0.34rem 0;
  }
}
</style>